"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
require("core-js/modules/es.array.filter");
require("core-js/modules/es.array.reduce");
require("core-js/modules/es.object.to-string");
require("core-js/modules/es.regexp.to-string");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._formatNumber = _formatNumber;
exports.getComponentText = getComponentText;
exports.makeListToString = makeListToString;
exports.makeNumberString = makeNumberString;
exports.makeRangeString = makeRangeString;
exports.makeUnit = makeUnit;
var _get = _interopRequireDefault(require("lodash/get"));
var _isFinite = _interopRequireDefault(require("lodash/isFinite"));
var _pluralize = require("@sravni/utils/lib/pluralize");
var _Components = require("../enums/Components");
var _Functions = _interopRequireDefault(require("../enums/Functions"));
var constructorHelper = _interopRequireWildcard(require("./constructorHelper"));
var _convertorHelper = require("./convertorHelper");
var _getDictionaryValue = _interopRequireDefault(require("./getDictionaryValue"));
var _replaceHelper = require("./replaceHelper");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function makeRangeString(_ref) {
  var product = _ref.product,
    config = _ref.config;
  var unit = config.unit,
    _config$fields = config.fields,
    from = _config$fields.from,
    to = _config$fields.to,
    template = config.template,
    _config$multiplier = config.multiplier,
    multiplier = _config$multiplier === void 0 ? 1 : _config$multiplier,
    defaultValue = config.defaultValue,
    _config$numberTemplat = config.numberTemplate,
    numberTemplate = _config$numberTemplat === void 0 ? '0' : _config$numberTemplat,
    _config$formats = config.formats,
    formats = _config$formats === void 0 ? [] : _config$formats;
  var fromValue = typeof from === 'object' ? getFunction(from.func)(from, product) : (0, _get.default)(product, from);
  var toValue = typeof to === 'object' ? getFunction(to.func)(to, product) : (0, _get.default)(product, to);
  var stringFrom = _formatNumber({
    value: fromValue,
    formats,
    numberTemplate,
    multiplier,
    product
  });
  var stringTo = _formatNumber({
    value: toValue,
    formats,
    numberTemplate,
    multiplier,
    product
  });
  if (stringTo && stringFrom) {
    var _template$both, _template$both2, _template$both3;
    if (stringTo === stringFrom) {
      var _template$equal, _template$equal2;
      var tail = makeUnit((template === null || template === void 0 ? void 0 : (_template$equal = template.equal) === null || _template$equal === void 0 ? void 0 : _template$equal.unit) || unit, toValue, product);
      return template !== null && template !== void 0 && (_template$equal2 = template.equal) !== null && _template$equal2 !== void 0 && _template$equal2.templateString ? (0, _replaceHelper.replaceTemplate)(template.equal.templateString, ['to', 'from', 'unit'], {
        to: stringTo,
        from: stringFrom,
        unit: tail
      }) : stringTo + " " + tail;
    }
    var tailTo = makeUnit((template === null || template === void 0 ? void 0 : (_template$both = template.both) === null || _template$both === void 0 ? void 0 : _template$both.unitTo) || unit, toValue, product);
    var tailFrom = makeUnit((template === null || template === void 0 ? void 0 : (_template$both2 = template.both) === null || _template$both2 === void 0 ? void 0 : _template$both2.unitFrom) || unit, fromValue, product);
    return template !== null && template !== void 0 && (_template$both3 = template.both) !== null && _template$both3 !== void 0 && _template$both3.templateString ? (0, _replaceHelper.replaceTemplate)(template.both.templateString, ['to', 'from', 'unitTo', 'unitFrom'], {
      to: stringTo,
      from: stringFrom,
      unitTo: tailTo,
      unitFrom: tailFrom
    }) : stringFrom + " - " + stringTo + tailTo;
  }
  if (stringTo && !stringFrom) {
    var _template$onlyTo, _template$onlyTo2;
    var _tail = makeUnit((template === null || template === void 0 ? void 0 : (_template$onlyTo = template.onlyTo) === null || _template$onlyTo === void 0 ? void 0 : _template$onlyTo.unit) || unit, toValue, product);
    return template !== null && template !== void 0 && (_template$onlyTo2 = template.onlyTo) !== null && _template$onlyTo2 !== void 0 && _template$onlyTo2.templateString ? (0, _replaceHelper.replaceTemplate)(template.onlyTo.templateString, ['to', 'unit'], {
      to: stringTo,
      unit: _tail
    }) : "\u0434\u043E " + stringTo + _tail;
  }
  if (stringFrom && !stringTo) {
    var _template$onlyFrom, _template$onlyFrom2;
    var _tail2 = makeUnit((template === null || template === void 0 ? void 0 : (_template$onlyFrom = template.onlyFrom) === null || _template$onlyFrom === void 0 ? void 0 : _template$onlyFrom.unit) || unit, fromValue, product);
    return template !== null && template !== void 0 && (_template$onlyFrom2 = template.onlyFrom) !== null && _template$onlyFrom2 !== void 0 && _template$onlyFrom2.templateString ? (0, _replaceHelper.replaceTemplate)(template.onlyFrom.templateString, ['from', 'unit'], {
      from: stringFrom,
      unit: _tail2
    }) : "\u043E\u0442 " + stringFrom + _tail2;
  }
  return defaultValue;
}
function makeNumberString(_ref2) {
  var product = _ref2.product,
    config = _ref2.config;
  var unit = config.unit,
    _config$multiplier2 = config.multiplier,
    multiplier = _config$multiplier2 === void 0 ? 1 : _config$multiplier2,
    defaultValue = config.defaultValue,
    _config$numberTemplat2 = config.numberTemplate,
    numberTemplate = _config$numberTemplat2 === void 0 ? '0' : _config$numberTemplat2,
    property = config.property,
    template = config.template,
    _config$formats2 = config.formats,
    formats = _config$formats2 === void 0 ? [] : _config$formats2;
  function getProduct() {
    var productValue = (0, _get.default)(product, property);
    if (!productValue && productValue !== 0) {
      return null;
    }
    return product;
  }
  var value = Number((0, _get.default)(getProduct(), property)) * (formats.length === 0 ? multiplier : 1);
  var tail = makeUnit(unit, value, product);
  var stringValue = _formatNumber({
    value,
    formats,
    numberTemplate,
    multiplier,
    product
  });
  if (stringValue) {
    return template ? (0, _replaceHelper.replaceTemplate)(template, ['property', 'unit'], {
      property: stringValue,
      unit: tail
    }) : "" + stringValue + tail;
  }
  return defaultValue;
}
function makeListToString(_ref3) {
  var product = _ref3.product,
    config = _ref3.config;
  return config.properties.reduce(function (out, value) {
    out.push(value.text ? product[value.property] && value.text : product[value.property]);
    return out;
  }, []).filter(Boolean).join(', ') || config.defaultValue;
}
function getComponentText(_ref4) {
  var product = _ref4.product,
    config = _ref4.config,
    vitrinsConfig = _ref4.vitrinsConfig,
    dictionaries = _ref4.dictionaries;
  switch (config.component) {
    case _Components.Components.StaticNumber:
      {
        return makeNumberString({
          product,
          config
        });
      }
    case _Components.Components.StaticString:
      {
        var value = (0, _get.default)(product, config.property);
        if (!value) {
          return config.defaultValue;
        }
        return config.template ? (0, _replaceHelper.replaceTemplate)(config.template, ['property'], {
          property: value
        }) : value;
      }
    case _Components.Components.StaticDate:
      {
        var _value = (0, _get.default)(product, config.property);
        return _value ? new Date(_value.toString()).toLocaleDateString() : '';
      }
    case _Components.Components.Range:
      {
        return makeRangeString({
          product,
          config
        });
      }
    case _Components.Components.Dictionary:
      {
        return (0, _getDictionaryValue.default)(product, config, vitrinsConfig, dictionaries);
      }
    default:
      {
        return '';
      }
  }
}
function makeUnit(unit, value, product, defaultUnit) {
  if (!unit) {
    return defaultUnit || '';
  }
  if (Array.isArray(unit)) {
    return (0, _pluralize.setupPluralize)(unit)(Number(value));
  }
  if (typeof unit === 'object') {
    if (!product) {
      throw new Error('Для формирования единицы измерения нужен продукт');
    }
    return (0, _get.default)(product, unit.property);
  }
  return unit;
}
function _formatNumber(_ref5) {
  var value = _ref5.value,
    product = _ref5.product,
    _ref5$formats = _ref5.formats,
    formats = _ref5$formats === void 0 ? [] : _ref5$formats,
    _ref5$numberTemplate = _ref5.numberTemplate,
    numberTemplate = _ref5$numberTemplate === void 0 ? '0' : _ref5$numberTemplate,
    _ref5$multiplier = _ref5.multiplier,
    multiplier = _ref5$multiplier === void 0 ? 1 : _ref5$multiplier;
  if (!(0, _isFinite.default)(value)) {
    return '';
  }
  var format = formats.find(function (f) {
    return value >= f.from && (!f.to || value < f.to);
  });
  if (!format) {
    return (0, _convertorHelper.toFinanceString)(value * multiplier, {
      template: numberTemplate
    });
  }
  var normalizedValue = value / format.from;
  var tail = makeUnit(format.unit, normalizedValue, product);
  var formattedValue = (0, _convertorHelper.toFinanceString)(normalizedValue, {
    template: format.numberTemplate || numberTemplate
  });
  return format.template ? (0, _replaceHelper.replaceTemplate)(format.template, ['property', 'unit'], {
    property: formattedValue,
    unit: tail
  }) : formattedValue + " " + tail;
}
function getFunction(fnName) {
  switch (fnName) {
    case _Functions.default.Min:
      {
        return constructorHelper.min;
      }
    case _Functions.default.Max:
      {
        return constructorHelper.max;
      }
    default:
      {
        throw Error("Can't find function for type " + fnName);
      }
  }
}